import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import closeImg from '../../assets/close.svg'
import SignContainer from '../auth/SignContainer'
import SocialLoginSmall from '../auth/SocialLoginSmall'

const PopupContainer = styled.div`
  display: none;
  position: fixed;
  bottom: 24px;
  left: 16px;
  right: 16px;
  background: white;
  padding: 20px;
  z-index: 999;
  border-radius: 12px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);

  @media only screen and (max-width: 744px) {
    display: block;
  }
`

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 12px;
  height: 12px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 12px;
    height: 12px;
    object-fit: contain;
  }

  &:hover {
    opacity: 0.6;
  }
`

const TitleContainer = styled.div`
  margin-bottom: 20px;
`

const Title = styled.h2`
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: ${props => (props.bold ? '16px' : '14px')};
  font-weight: ${props => (props.bold ? '600' : '400')};
  line-height: 1.4;
  color: #000000;
  margin: 0;
  margin-bottom: ${props => (props.bold ? '4px' : '0')};
`

const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
`

const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  padding: 1px 16px 1px 1px;
  background: #000000;
  border-radius: 20px;
  border: none;
  height: 40px;
  cursor: pointer;
  color: white;
  font-family: Helvetica Neue;
  font-size: 14px;
  font-weight: 500;
`

const FacebookButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #1877f2;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 20px;
    height: 20px;
  }
`

const WelcomePopup = () => {
  const closeForever = useRef(false)
  const [showPopup, setShowPopup] = useState(false)
  const [showSignIn, setShowSignIn] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (closeForever.current) return

      if (document.querySelector('#scroll-box').scrollTop > 500) {
        window.removeEventListener('scroll', handleScroll)

        const timer = setTimeout(() => {
          setShowPopup(true)
        }, 7000)
      }
    }

    document.querySelector('#scroll-box').addEventListener('scroll', handleScroll)

    return () => {
      document.querySelector('#scroll-box').removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handleClose = () => {
    closeForever.current = true
    setShowPopup(false)
  }

  if ((!showPopup && !showSignIn) || closeForever.current) return null

  if (showSignIn) {
    return <SignContainer authState="LOGIN" handleReturn={() => setShowSignIn(false)} handleLogIn={() => {}} handleSignUp={() => {}} />
  }

  return (
    <PopupContainer>
      <CloseButton onClick={handleClose}>
        <img src={closeImg} alt="Close" />
      </CloseButton>
      <TitleContainer>
        <Title bold>Welcome to DecorMatters</Title>
        <Title>Find design inspiration. Create your home design. Play creative design games.</Title>
      </TitleContainer>
      <SocialLoginSmall isSignIn={true} showForm={false} setShowForm={() => setShowSignIn(true)} />
    </PopupContainer>
  )
}

export default WelcomePopup
